import resolvePieveApiBaseUrl from '@/lib/resolvePieveApiBaseUrl.js';
import { store } from '@/redux/lib/configureStore.js';
import { runtimeApiBaseUrl } from '@/redux/selectors/pieveSelectors/runtimeSelectors.js';

const getPieveApiBaseUrl = () => {
  const reduxApiBaseUrl = runtimeApiBaseUrl(store.getState());

  if (reduxApiBaseUrl) {
    return reduxApiBaseUrl;
  }

  return resolvePieveApiBaseUrl();
};

export default getPieveApiBaseUrl;
